(() => {
  function sortGrid(grid) {
    const items = Array.from(grid.children).filter((el) => el.tagName === 'LI');
    if (items.length === 0) return;

    const available = [];
    const soldOut = [];
    items.forEach((item) => {
      const isSoldOut = item.querySelector('[data-sold-out="true"]') != null;
      (isSoldOut ? soldOut : available).push(item);
    });

    const desiredOrder = available.concat(soldOut);
    let needsReorder = false;
    for (let i = 0; i < desiredOrder.length; i++) {
      if (desiredOrder[i] !== items[i]) {
        needsReorder = true;
        break;
      }
    }
    if (!needsReorder) return;

    const fragment = document.createDocumentFragment();
    desiredOrder.forEach((item) => fragment.appendChild(item));
    grid.appendChild(fragment);
  }

  function watchGrid(grid) {
    sortGrid(grid);

    // A lista é recarregada via infinite scroll/paginação do results-list
    // (Web Component do tema) — observamos mudanças nos filhos pra reordenar
    // de novo sempre que novos produtos entrarem na grade.
    const observer = new MutationObserver(() => sortGrid(grid));
    observer.observe(grid, { childList: true });
  }

  function init() {
    document.querySelectorAll('ul.product-grid').forEach(watchGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
